import Vue from 'vue';
import Vuex from 'vuex';
import workspaces from '@/store/modules/workspaces';
import currentWorkspace from '@/store/modules/currentWorkspace';
import virtualMachines from '@/store/modules/virtualMachines';
import userFormData from '@/store/modules/userFormData';
import workspaceUsers from '@/store/modules/workspaceUsers';
import publicIPAddresses from '@/store/modules/publicIPAddresses';
import privateNetworks from '@/store/modules/privateNetworks';
import nats from '@/store/modules/nats';
import networkCards from '@/store/modules/virtualNetworkCards';
import dedicatedNetworkCards from '@/store/modules/dedicatedNetworkCards';
import regions from '@/store/modules/regions';
import snapshot from '@/store/modules/snapshot';
import billingPeriods from '@/store/modules/billingPeriods';
import dedicatedMachines from '@/store/modules/dedicatedMachines';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    workspaces,
    currentWorkspace,
    virtualMachines,
    dedicatedMachines,
    userFormData,
    workspaceUsers,
    publicIPAddresses,
    privateNetworks,
    nats,
    networkCards,
    dedicatedNetworkCards,
    regions,
    snapshot,
    billingPeriods,
  },
});
